/**
 * Stash the last host AUTH_REQUEST context so AUTH_CHALLENGE can retry with proof.
 * Cleared on terminal auth outcomes (AUTH_SUCCESS / AUTH_ERROR / challenge sign failure)
 * so JWTs and sockets are not held after auth completes or fails.
 */

export type PendingHostAuth = {
  machineId: string;
  isGuestMode: boolean;
  accessToken: string;
  cloudHostToken?: string;
  rawSocket: WebSocket | null;
};

let pending: PendingHostAuth | null = null;

export const setPendingHostAuth = (next: PendingHostAuth | null): void => {
  pending = next;
};

export const getPendingHostAuth = (): PendingHostAuth | null => pending;

export const clearPendingHostAuth = (): void => {
  pending = null;
};
